var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.148 0H0V133.106H177.148V0Z", fill: "#FF681C" },
      }),
      _c("path", {
        attrs: {
          d: "M177 35V133H73C73 78.8776 119.564 35 177 35Z",
          fill: "#FF974A",
        },
      }),
      _c("path", {
        attrs: {
          d: "M-1.96448e-06 98L6.60295e-06 -1.00726e-05L104 -9.80646e-07C104 54.1224 57.4358 98 -1.96448e-06 98Z",
          fill: "#FF974A",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }